import React from "react";
import ClassplusLogo from "../../../assets/Images/classplus-logo.svg";
//import { Link } from "react-router-dom";

const Header = () => {
  return (
      <div className="headerContainer">
        <div className="headerLogoDiv">
            <img src={ClassplusLogo} alt=""/>
        </div>
      </div>
  );
};

export default Header;
